import { gql } from '@apollo/client';

const GET_FEATURE_TOGGLES_LIST = gql`
  query getFeatureTogglesList {
    getFeatureTogglesList {
      isActive
      name
      friendlyName
    }
  }
`;

const CURRENT_USER = gql`
  query currentUserProvider {
    currentUserProvider {
      id
      email
      phone
      helpscoutId
      mustCompleteRegistration
      accountLocked
      firstName
      lastName
      patientFacingName
      picture
      zocdocVideoLink
      providerRoom
    }
  }
`;

const GET_ANALYTICS_ID = gql`
  query getAnalyticsProviderId {
    getAnalyticsProviderId
  }
`;

const GET_APPOINTMENT_NOTES = gql`
  query healthCoachGetAppointmentNotes($appointmentId: String!) {
    healthCoachGetAppointmentNotes(appointmentId: $appointmentId) {
      created
      noteText
      id
    }
  }
`;

const APPOINTMENTS = gql`
  query Appointments($includeNut: Boolean) {
    appointments(includeNut: $includeNut) {
      id
      date
      startTime
      status
      appointmentTypeId
      timezoneName
      provider {
        id
        displayName
        zocdocVideoLink
      }
    }
  }
`;

const LABS = gql`
  query Labs {
    labs {
      id
      status
      created
      results {
        pdf
        outcome {
          hormone
          value
          unit
          referenceRange
          abnormal
        }
      }
      currentStep {
        step
        eta
        returnStatus
        delivered
      }
    }
  }
`;

const GET_USER_PCP = gql`
  query getPcp {
    getPcp {
      id
      practice
      address
      address2
      city
      state
      zip
      county
      phone
      fax
      firstname
      lastname
      fullname
      email
      gender
      title
      specialty
      sicCode
      locationAddress
      specialty2
      specialty3
      specialty4
      specialty5
      npi
      internalId
    }
  }
`;

const GET_LAST_SEENS = gql`
  query providerGetLastSeens {
    providerGetLastSeens {
      date
      appointmentId
      startTime
      departmentId
      appointmentStatus
      patientId
      duration
      templateAppointmentTypeId
      hl7ProviderId
      lastModifiedBy
      appointmentTypeId
      lastModified
      appointmentType
      providerId
      chargeEntryNotRequired
      scheduledDateTime
      coordinatorEnterprise
      templateAppointmentId
      patientAppointmentTypename
      dateStart
      dateEnd
      tzAbbr
      patient {
        guarantorcountrycode
        firstname
        primarydepartmentid
        contactpreference
        state
        racename
        email
        emailexists
        industrycode
        departmentid
        confidentialitycode
        homephone
        firstappointment
        language6392code
        guarantorstate
        patientid
        dob
        guarantordob
        zip
        primaryproviderid
        guarantoraddresssameaspatient
        address1
        guarantorrelationshiptopatient
        driverslicense
        patientphoto
        portaltermsonfile
        status
        consenttocall
        lastname
        guarantorfirstname
        guarantorphone
        city
        lastappointment
        guarantoremail
        guarantorcity
        mobilephone
        maritalstatus
        guarantorzip
        guarantoraddress1
        countrycode
        registrationdate
        hasmobile
        sex
        maritalstatusname
        privacyinformationverified
        ethnicitycode
        consenttotext
        countrycode3166
        caresummarydeliverypreference
        guarantorlastname
        guarantorcountrycode3166
      }
    }
  }
`;

const GET_TODAYS_UPCOMINGS = gql`
  query providerGetTodaysUpcomings {
    providerGetTodaysUpcomings {
      date
      appointmentId
      startTime
      departmentId
      appointmentStatus
      patientId
      duration
      templateAppointmentTypeId
      hl7ProviderId
      lastModifiedBy
      appointmentTypeId
      lastModified
      appointmentType
      providerId
      chargeEntryNotRequired
      scheduledDateTime
      coordinatorEnterprise
      templateAppointmentId
      patientAppointmentTypename
      dateStart
      dateEnd
      tzAbbr
      isMobileUser
      isSlot
      patient {
        guarantorcountrycode
        firstname
        primarydepartmentid
        contactpreference
        state
        racename
        email
        emailexists
        industrycode
        departmentid
        confidentialitycode
        homephone
        firstappointment
        language6392code
        guarantorstate
        patientid
        dob
        guarantordob
        zip
        primaryproviderid
        guarantoraddresssameaspatient
        address1
        guarantorrelationshiptopatient
        driverslicense
        patientphoto
        portaltermsonfile
        status
        consenttocall
        lastname
        guarantorfirstname
        guarantorphone
        city
        lastappointment
        guarantoremail
        guarantorcity
        mobilephone
        maritalstatus
        guarantorzip
        guarantoraddress1
        countrycode
        registrationdate
        hasmobile
        sex
        maritalstatusname
        privacyinformationverified
        ethnicitycode
        consenttotext
        countrycode3166
        caresummarydeliverypreference
        guarantorlastname
        guarantorcountrycode3166
      }
    }
  }
`;

const GET_UPCOMINGS = gql`
  query providerGetUpcomings($day: String) {
    providerGetUpcomings(day: $day) {
      id
      date
      appointmentId
      startTime
      departmentId
      appointmentStatus
      patientId
      duration
      templateAppointmentTypeId
      hl7ProviderId
      lastModifiedBy
      appointmentTypeId
      lastModified
      appointmentType
      providerId
      chargeEntryNotRequired
      scheduledDateTime
      coordinatorEnterprise
      templateAppointmentId
      patientAppointmentTypename
      dateStart
      dateEnd
      tzAbbr
      isMobileUser
      isSlot
      patient {
        id
        guarantorcountrycode
        firstname
        primarydepartmentid
        contactpreference
        state
        racename
        email
        emailexists
        industrycode
        departmentid
        confidentialitycode
        homephone
        firstappointment
        language6392code
        guarantorstate
        patientid
        dob
        guarantordob
        zip
        primaryproviderid
        guarantoraddresssameaspatient
        address1
        guarantorrelationshiptopatient
        driverslicense
        patientphoto
        portaltermsonfile
        status
        consenttocall
        lastname
        guarantorfirstname
        guarantorphone
        city
        lastappointment
        guarantoremail
        guarantorcity
        mobilephone
        maritalstatus
        guarantorzip
        guarantoraddress1
        countrycode
        registrationdate
        hasmobile
        sex
        maritalstatusname
        privacyinformationverified
        ethnicitycode
        consenttotext
        countrycode3166
        caresummarydeliverypreference
        guarantorlastname
        guarantorcountrycode3166
      }
    }
  }
`;

const GET_PATIENT_BY_ID = gql`
  query getProviderPatientById($id: String!) {
    getProviderPatientById(id: $id) {
      athenaId
      firstname
      lastname
      dob
      email
      phone
      photo
      state
      preferredPronouns
      helpscoutId
      medicalHistory {
        hasHypo
        hasHashi
        hasHyper
        hasDiabetes
        thyroidRemoved
        radiationTherapy
        hypoNotes
        hashiNotes
        hyperNotes
        thyroidRemovedNotes
        radiationTherapyNotes
      }
      isMobileUser
    }
  }
`;

const GET_PATIENT_PHOTO = gql`
  query getPatientPhoto($id: String!) {
    getPatientPhoto(id: $id)
  }
`;

const GET_PATIENT_QUICKVIEW = gql`
  query getProviderPatientQuickview($id: String!) {
    getProviderPatientQuickview(id: $id) {
      patientId
      email
      lastName
      firstName
      address1
      address2
      city
      state
      zip
      countryCode
      mobilePhone
      homePhone
      industrycode
      sex
      status
      departmentId
      privacyInformationVerified
      primaryDepartmentId
      emailExists
      patientPhoto
      registrationDate
      guarantorCountryCode
      dob
      guarantorRelationshipToPatient
      consentToText
      countryCode3166
      guarantorCountryCode3166
      primaryProviderId
      lastAppointment
      medicationHistoryConsentVerified
      driverslicenseurl
    }
  }
`;

const GET_INSURANCE_ON_FILE_FOR_PATIENT = gql`
  query getInsurancesOnFileForPatient($patientId: Int!) {
    getInsurancesOnFileForPatient(patientId: $patientId) {
      insurancePolicyHolderCountryCode
      sequenceNumber
      insurancePolicyHolderlastname
      insuredEntityTypeId
      insuranceIdNumber
      insurancePolicyHolderstate
      insurancePolicyHolderzip
      relationshipToInsured
      eligibilityStatus
      policyNumber
      insurancePolicyHolderaddress1
      insurancePackageAddress1
      insurancePolicyHoldersex
      eligibilityReason
      ircName
      insurancePlanName
      insuranceType
      insurancePhone
      insurancePackageState
      insurancePackageCity
      relationshipToInsuredId
      insuranceId
      insurancePolicyHolder
      eligibilityLastChecked
      insurancePolicyHolderFirstName
      insurancePackageId
      insurancePolicyHolderCountryIso3166
      insurancePlanDisplayName
      insurancePolicyHoldercity
      insurancePackageZip
      insuranceCompany
      groupId
      payerId
    }
  }
`;

const GET_CARE_LOCATIONS = gql`
  query getProviderCareLocations($id: String!) {
    getProviderCareLocations(id: $id) {
      pharmacy {
        id
        placeId
        name
        formattedAddress
        phone
      }
      labCenter {
        id
        placeId
        name
        formattedAddress
        phone
      }
      pcp {
        id
        practice
        address
        address2
        city
        state
        zip
        county
        phone
        fax
        firstname
        lastname
        fullname
        email
        gender
        title
        specialty
        sicCode
        locationAddress
        specialty2
        specialty3
        specialty4
        specialty5
        npi
        internalId
      }
    }
  }
`;

const SEARCH_PATIENT_BY_NAME = gql`
  query searchProviderPatientsByName($search: String!) {
    searchProviderPatientsByName(search: $search) {
      firstName
      currentDepartmentId
      providerGroupId
      lastName
      localPatientId
      state
      city
      ssn
      countryId
      homePhone
      mobilePhone
      patientId
      sex
      dob
      translatedHomePhoneIndex
      zip
      currentDepartment
      address1
      translatedMobilePhoneIndex
    }
  }
`;

const GET_PATIENT_SYMPTOMS = gql`
  query getProviderPatientOverallSymptoms($id: String!) {
    getProviderPatientOverallSymptoms(id: $id) {
      global {
        date
        hasLabs
        average
        foodTracked {
          id
          date
          time
          rating
          foodCategory
          foodItem
          symptoms
        }
      }
      details {
        id
        name
        color
        textLineColor
        values {
          id
          name
          previousAvg
          values {
            id
            date
            values
          }
        }
      }
    }
  }
`;

const GET_LAB_CHART_VALUES = gql`
  query providerGetLabChartValues($patientId: String!) {
    providerGetLabChartValues(patientId: $patientId) {
      tpo {
        id
        date
        value
        isPaloma
        isSelfEntered
        units
      }
      tsh {
        id
        date
        value
        isPaloma
        isSelfEntered
        units
      }
      ft3 {
        id
        date
        value
        isPaloma
        isSelfEntered
        units
      }
      ft4 {
        id
        date
        value
        isPaloma
        isSelfEntered
        units
      }
      vitD {
        id
        date
        value
        isPaloma
        isSelfEntered
        units
      }
      rT3 {
        id
        date
        value
        isPaloma
        isSelfEntered
        units
      }
      prescriptions {
        x
        documentDescriptions
      }
    }
  }
`;

const GET_PATIENT_MOBILE_COURSES = gql`
  query providerGetPatientMobileCourses($patientId: String!) {
    providerGetPatientMobileCourses(patientId: $patientId) {
      byWeek {
        week
        journeyName
        courses {
          order
          title
          isStarted
          progress
          isComplete
          id
        }
      }
    }
  }
`;

const GET_APPOINTMENTS_AND_TICKLERS = gql`
  query providerGetAppointmentsAndTicklers($patientId: String!) {
    providerGetAppointmentsAndTicklers(patientId: $patientId) {
      appointments {
        id
        date
        startTime
        status
        appointmentTypeId
        appointmentType
        timezoneName
        encounterId
        duration
        provider {
          id
          displayName
          zocdocVideoLink
        }
      }
      ticklers {
        approximateDate
        type
      }
    }
  }
`;

const GET_APPOINTMENT_SUMMARY = gql`
  query providerGetAppointmentSummary($appointmentId: String!) {
    providerGetAppointmentSummary(id: $appointmentId) {
      instructions
      goals
      discussionNotes
      assessment
      prescription {
        encounterId
        orderType
        prescriptionId
        providerId
        description
        instructions
        patientNote
        rxDate
        quantityValue
        dosageQuantity
      }
      diagnoses
      physicalExam
      hpi
    }
  }
`;

const GET_CONVERSATIONS_SEARCH = gql`
  query getProviderSearchConversations($search: String!, $assignedToMe: Boolean, $pageNumber: Int) {
    getProviderSearchConversations(search: $search, assignedToMe: $assignedToMe, pageNumber: $pageNumber) {
      conversations {
        id
        number
        threads
        type
        status
        state
        subject
        mailboxId
        preview
        isClinicalTeam
        userUpdatedAt
        customerWaitingSince {
          time
          friendly
        }
        tags {
          id
          color
          tag
        }
        primaryCustomer {
          id
          type
          first
          last
          email
          photoUrl
        }
        customFields {
          name
          value
          text
        }
      }
      _links {
        self {
          href
        }
        first {
          href
        }
        last {
          href
        }
      }
      page {
        size
        totalElements
        totalPages
        number
      }
    }
  }
`;

const GET_CONVERSATIONS_BY_APPOINTMENT_ID = gql`
  query providerGetConversationByAppointmentId($appointmentId: String!) {
    providerGetConversationByAppointmentId(appointmentId: $appointmentId) {
      conversations {
        id
        number
        threads
        type
        status
        state
        subject
        mailboxId
        preview
        userUpdatedAt
        customerWaitingSince {
          time
          friendly
        }
        tags {
          id
          color
          tag
        }
        primaryCustomer {
          id
          type
          first
          last
          email
          photoUrl
        }
        customFields {
          name
          value
          text
        }
      }
      _links {
        self {
          href
        }
        first {
          href
        }
        last {
          href
        }
      }
      page {
        size
        totalElements
        totalPages
        number
      }
    }
  }
`;

const GET_CONVERSATIONS = gql`
  query getProviderConversations($pageNumber: Int, $status: String) {
    getProviderConversations(pageNumber: $pageNumber, status: $status) {
      conversations {
        id
        number
        threads
        type
        status
        state
        subject
        mailboxId
        preview
        isClinicalTeam
        userUpdatedAt
        customerWaitingSince {
          time
          friendly
        }
        tags {
          id
          color
          tag
        }
        primaryCustomer {
          id
          type
          first
          last
          email
          photoUrl
        }
        customFields {
          name
          value
          text
        }
      }
      _links {
        self {
          href
        }
        first {
          href
        }
        last {
          href
        }
      }
      page {
        size
        totalElements
        totalPages
        number
      }
    }
  }
`;

const GET_HELPSCOUT_USERS = gql`
  query getHelpscoutUsers {
    getHelpscoutUsers {
      id
      firstName
      lastName
      email
      role
      timezone
      type
      photoUrl
      initials
      mention
      jobTitle
      phone
      alternateEmails
    }
  }
`;

const GET_CONVERSATION_BY_ID = gql`
  query providerGetConversationById($conversationId: String!) {
    providerGetConversationById(conversationId: $conversationId) {
      id
      number
      threads
      type
      folderId
      status
      state
      subject
      preview
      mailboxId
      isClinicalTeam
      assignee {
        id
        type
        first
        last
        email
      }
      createdBy {
        id
        type
        email
      }
      createdAt
      closedBy
      closedByUser {
        id
        type
        first
        last
        photoUrl
        email
      }
      closedAt
      userUpdatedAt
      convoTree {
        tree
        parent
      }
      customerWaitingSince {
        time
        friendly
      }
      tags {
        id
        color
        tag
      }
      cc
      bcc
      primaryCustomer {
        id
        type
        first
        last
        email
      }
      customFields {
        name
        value
        text
      }
      _embedded {
        threads {
          id
          type
          status
          state
          action {
            type
            text
          }
          body
          customer {
            id
            type
            first
            last
            email
            photoUrl
          }
          createdBy {
            id
            type
            first
            last
            email
            photoUrl
          }
          createdAt
          openedAt
          _embedded {
            attachments {
              id
              filename
              mimeType
              width
              height
              _links {
                self {
                  href
                }
                data {
                  href
                }
                web {
                  href
                }
              }
            }
          }
        }
      }
      _links {
        self {
          href
        }
        first {
          href
        }
        last {
          href
        }
      }
      page {
        size
        totalElements
        totalPages
        number
      }
    }
  }
`;

const GET_DASHBOARD_CARDS_DATA = gql`
  query getProviderDashboardCardsData {
    getProviderDashboardCardsData {
      past
      thisMonth
      future
    }
  }
`;

const GET_OPEN_CONVERSATION_COUNT = gql`
  query getProviderConversationsOpenedCount {
    getProviderConversationsOpenedCount {
      count
    }
  }
`;

const GET_CURRENT_INTAKE_VALUES = gql`
  query getProviderCurrentIntakeValues($id: String!) {
    getProviderCurrentIntakeValues(id: $id) {
      medicalhistory {
        question
        answer
        note
        questionId
      }
      gynhistory {
        question
        answer
        note
        questionId
      }
      allergies {
        rxnormcode
        allergenid
        allergenname
        note
        lastmodifiedby
        deactivateduser
        criticality
        deactivatedate
        reactions {
          severitysnomedcode
          reactionname
          snomedcode
          severity
        }
      }
      familyHistory {
        relation
        problems {
          problemId
          snomedcode
          note
          description
        }
      }
      socialHistory {
        question
        answer
        note
        questionId
      }
      surgicalHistory {
        description
        procedureid
        note
        procedurecode
      }
      problems {
        id
        lastModifiedDateTime
        name
        problemId
        events {
          eventtype
          startdate
          note
          createddate
          createdby
        }
        code
      }
    }
  }
`;

const GET_PROFILE = gql`
  query getProviderProfile {
    getProviderProfile {
      id
      departmentId
      lastName
      firstName
      username
      patientFacingName
      email
      doctorType
      providerGroup
      networks
      education
      certification
      experience
      startingYear
      npi
      timeZones
      primaryId
      recordId
      bio
      picture
      question1
      question2
      tags
      zocdocVideoLink
      asyncAccepted
      zocdocName
      department
      acceptNewPatients
    }
  }
`;

const GET_MEDICATIONS_ON_FILE = gql`
  query providerGetMedicationsForPatient($id: String!) {
    providerGetMedicationsForPatient(id: $id) {
      medicationId
      medication
      dose
      frequency
      isActive
      events {
        eventdate
        type
        userdisplayname
      }
    }
  }
`;

const GET_MEDICATION_REMINDERS = gql`
  query providerGetMedicationRemindersForPatient($id: String!) {
    providerGetMedicationRemindersForPatient(id: $id) {
      id
      medicationName
      dose
      frequency
      times
      isActive
      notify
    }
  }
`;

const GET_CALENDAR_FOR_MONTH = gql`
  query getProviderCalendarForMonth($date: String!) {
    getProviderCalendarForMonth(date: $date) {
      openSlots {
        id
        date
        count
      }
      booked {
        id
        date
        count
      }
    }
  }
`;

const GET_CALENDAR_BETWEEN_DATES = gql`
  query getProviderCalendarBetweenDates($startDate: String!, $endDate: String!) {
    getProviderCalendarBetweenDates(startDate: $startDate, endDate: $endDate) {
      openSlots {
        id
        date
        count
      }
      booked {
        id
        date
        count
      }
    }
  }
`;

const GET_LABS_LIST = gql`
  query providersGetLabLists($patientId: String!) {
    providersGetLabLists(patientId: $patientId) {
      date
      labResultId
      attachmentExists
      lab
      status
      analytes {
        analyte
        abnormalflag
        value
        unit
        status
        isManualUpload
        resultStatus
        analyteid
        id
      }
    }
  }
`;

const GET_LAB_RESULT_DOCUMENTS = gql`
  query providerGetLabResultDocuments($patientId: String!, $labResultId: Int!) {
    providerGetLabResultDocuments(patientId: $patientId, labResultId: $labResultId) {
      pageordering
      pageid
      contenttype
    }
  }
`;

const GET_LAB_RESULT_DOCUMENTS_PAGE = gql`
  query providerGetLabResultDocumentsPage($patientId: String!, $labResultId: Int!, $pageId: String!) {
    providerGetLabResultDocumentsPage(patientId: $patientId, labResultId: $labResultId, pageId: $pageId) {
      attachement
      mimeType
    }
  }
`;

const GET_AIP_RECIPES_BY_FILTER = gql`
  query getAipRecipesByFilterFromWeb($filterText: String, $filterCategory: FilterMealTypes, $idsToExclude: [String], $excludedAllergens: [String]) {
    getAipRecipesByFilterFromWeb(filterText: $filterText, filterCategory: $filterCategory, idsToExclude: $idsToExclude, excludedAllergens: $excludedAllergens) {
      name
      image
      id
      serving
      totalTimeMinutes
    }
  }
`;

const GET_AIP_RECIPE = gql`
  query getAipRecipeFromWeb($id: String!) {
    getAipRecipeFromWeb(id: $id) {
      id
      airtableId
      name
      image
      serving
      activeTimeMinutes
      totalTimeMinutes
      calories
      ingredients
      instructions
      options
      author
      authorBio
      authorImage
      instagramLink
      authorWebsite
      highProtein
      balanced
      lowFat
      highFiber
      lowCarb
      lowSodium
      vegan
      vegetarian
      paleo
      dairyFree
      glutenFree
      wheatFree
      fatFree
      lowSugar
      eggFree
      nightshadeFree
      alcoholFree
      caffeineFree
      peanutFree
      treeNutFree
      soyFree
      fishFree
      shellfishFree
      breakfast
      lunch
      dinner
      snack
      active
      isFavorite
    }
  }
`;

const GET_ARTICLES_FOR_CATEGORY = gql`
  query getArticlesInCategoryFromWeb($categoryId: String, $take: Int, $skip: Int, $filter: String, $favorites: Boolean, $idsToExclude: [String]) {
    getArticlesInCategoryFromWeb(categoryId: $categoryId, take: $take, skip: $skip, filter: $filter, favorites: $favorites, idsToExclude: $idsToExclude) {
      title
      thumbnailUrl
      id
      content
      quickPostSummary
      readMore
      tag {
        id
        name
      }
      categories {
        id
        name
      }
    }
  }
`;

const GET_ARTICLES_CATEGORIES = gql`
  query getArticleCategories {
    getArticleCategories {
      id
      name
    }
  }
`;

const GET_RANDOM_ARTICLES_WITH_TAG = gql`
  query getArticlesWithTag($limit: Int, $tag: String!) {
    getArticlesWithTag(limit: $limit, tag: $tag) {
      title
      thumbnailUrl
      id
      tag {
        id
        name
      }
      categories {
        id
        name
      }
    }
  }
`;

const GET_ARTICLE_BY_ID = gql`
  query getArticleByIdFromWeb($id: String!) {
    getArticleByIdFromWeb(id: $id) {
      title
      thumbnailUrl
      id
      content
      quickPostSummary
      readMore
      isFavorite
      tag {
        id
        name
      }
      categories {
        id
        name
      }
    }
  }
`;

const GET_SPEAKER_SERIES = gql`
  query getSpeakerSeries {
    getSpeakerSeries {
      name
      slug
      publishedOn
      smallDescription
      duration
      videoLink
      descriptionCopy
      image
      description
      speaker_1
      codeFromHttpsAppSistrixComEnVideoSnippetGenerator
      transcript
      embedUrl
      videoLinkMp4Mov
      speaker_2
      itemId
      createdOn
      speaker_3
      updatedOn
      thumbnailUrl
      rid
      collectionId
      airtableId
      id
    }
  }
`;

const GET_THYROID_GUIDES = gql`
  query getThyroidGuides {
    getThyroidGuides {
      name
      slug
      collectionId
      itemId
      guidePdfLink
      title
      summary
      bgColor
      image
      subtitle
      description
      included1
      included1Image
      included1Description
      included2
      included2Image
      included2Description
      included3
      included3Image
      included3Description
      included4
      included4Image
      included4Description
      order
      airtableId
      id
    }
  }
`;

const GET_PATIENT_CHART_ALERTS = gql`
  query getProviderPatientChartAlert($id: String!) {
    getProviderPatientChartAlert(id: $id) {
      lastmodified
      notetext
      lastmodifiedby
    }
  }
`;

const GET_PATIENT_BASELINE_SURVEY_ANSWERS = gql`
  query getBaselineSurveyAnswersProvider($id: String!) {
    getBaselineSurveyAnswersProvider(id: $id) {
      id
      status
      values
      updatedAt
    }
  }
`;

const GET_PATIENT_FOLLOWUP_SURVEY_ANSWERS = gql`
  query getFollowUpSurveyAnswersProvider($surveyName: String!, $id: String!) {
    getFollowUpSurveyAnswersProvider(surveyName: $surveyName, id: $id) {
      survey
      answers {
        id
        status
        values
        updatedAt
      }
    }
  }
`;

const GET_PATIENT_SURVEYS_AVERAGES = gql`
  query providerSurveyAnswersProvider($id: String!) {
    providerSurveyAnswersProvider(id: $id) {
      survey
      avg {
        hypothyroidSymptoms {
          values
          answers {
            question
            value
            answer
          }
        }
        tiredness {
          values
          answers {
            question
            value
            answer
          }
        }
        cognitiveComplaints {
          values
          answers {
            question
            value
            answer
          }
        }
        anxiety {
          values
          answers {
            question
            value
            answer
          }
        }
        depressivity {
          values
          answers {
            question
            value
            answer
          }
        }
        impairedDailyLife {
          values
          answers {
            question
            value
            answer
          }
        }
        cosmeticComplaints {
          values
          answers {
            question
            value
            answer
          }
        }
        overallQoL {
          values
          answers {
            question
            value
            answer
          }
        }
      }
    }
  }
`;

const GET_PATIENT_SURVEYS_INFO = gql`
  query getSurveysInfoProvider($id: String!) {
    getSurveysInfoProvider(id: $id) {
      mustCompleteBaselineSurvey
      statuses {
        id
        name
        status
        triggerOn
        lastUpdatedOn
      }
    }
  }
`;

const GET_PATIENT_CASES = gql`
  query providerGetPatientCases($patientId: String!) {
    providerGetPatientCases(patientId: $patientId) {
      id
      appointmentId
      assignedTo
      clinicalProviderId
      createdDate
      createdDatetime
      createdUser
      deletedDatetime
      departmentId
      description
      documentClass
      documentDescription
      documentRoute
      documentSource
      documentSubclass
      documentTypeId
      encounterId
      externalAccessionId
      externalNote
      facilityId
      internalAccessionId
      internalNote
      lastModifiedDate
      lastModifiedDatetime
      lastModifiedUser
      observationDatetime
      patientCaseAttachments
      patientCaseId
      patientId
      phoneMessageId
      priority
      providerId
      status
      subject
      tieToOrderId
      hcFilledFormId
    }
  }
`;

const GET_PATIENT_CASE = gql`
  query providerGetPatientCase($patientId: String!, $patientCaseId: String!) {
    providerGetPatientCase(patientId: $patientId, patientCaseId: $patientCaseId) {
      id
      actionNote
      assignedTo
      callbackName
      callbackNumber
      callbackNumberType
      callType
      clinicalProviderId
      createdDate
      createdDatetime
      createdUser
      deletedDatetime
      departmentId
      description
      documentClass
      documentDescription
      documentRoute
      documentSubclass
      documentTypeId
      encounterId
      externalAccessionId
      externalNote
      facilityId
      internalAccessionId
      internalNote
      lastModifiedDate
      lastModifiedDatetime
      lastModifiedUser
      observationdatetime
      outboundOnly
      patientCaseAttachments
      patientCaseId
      patientId
      priority
      providerId
      providerUsername
      status
      subject
      tiedToProcedureOrSurgery
      tieToOrderId
      filledForm {
        id
        healthCoach {
          id
          displayName
        }
        form {
          id
          name
          description
        }
        values
        updatedAt
      }
    }
  }
`;

const GET_TALKING_POINTS = gql`
  query providerGetTalkingPoints($patientId: String!) {
    providerGetTalkingPoints(patientId: $patientId) {
      id
      palomaExpectations
      thyroidMedAdjustment
      overallWellBeing
      isMobileUser
      bmi {
        feet
        inches
        weight
        bmi
        bmiString
        timestamp
      }
      flags {
        marker
        currentFlag
        previousFlag
        currentValue
        previousValue
        previousUnit
        currentUnit
      }
      problems {
        id
        lastModifiedDateTime
        name
        problemId
        code
        events {
          eventtype
          startdate
          note
          createddate
          createdby
        }
      }
    }
  }
`;

const GET_HS_TAGS_LIST = gql`
  query getHelpscoutTagsList {
    getHelpscoutTagsList {
      tags {
        id
        slug
        name
        color
        createdAt
        ticketCount
      }
    }
  }
`;

const GET_CLINICAL_TEAM_CONVERSATION_ID = gql`
  query getPatientClinicalTeamActiveConversationId($athenaId: String!) {
    getPatientClinicalTeamActiveConversationId(athenaId: $athenaId)
  }
`;

const GET_HPIS = gql`
  query getHPIs($athenaId: String!, $hpiTarget: String) {
    getHPIs(athenaId: $athenaId, hpiTarget: $hpiTarget) {
      hpi
      copyable
      aiResult {
        summary
        talkingPoints
        recommendations
        surveySummary
        talkingPointsReasoning
        recommendationsReasoning
      }
    }
  }
`;

const GET_INTAKE_STATUS = gql`
  query healthCoachGetIntakeStatus($athenaId: String!) {
    healthCoachGetIntakeStatus(athenaId: $athenaId) {
      notOk
      message
      notOkMeno
      messageMeno
      notOkWeightloss
      messageWeightloss
    }
  }
`;

const GET_PRESET_PLANS = gql`
  query getThyroidPrograms {
    getThyroidPrograms {
      id
      name
      description
      icon
      bgMainColor
      bgBubblesColor
      titleColor
      descriptionColor
      isActive
      isArchived
      isPro
      memberOnly
      createdAt
      updatedAt
      order
    }
  }
`;

const GET_THYROID_JOURNEY_SUMMARY = gql`
  query getThyroidJourneySummaryHealthCoach($userId: String!) {
    getThyroidJourneySummaryHealthCoach(userId: $userId) {
      currentWeek
      weeks {
        journeyName
        week
        courses {
          id
          title
          description
          isActive
          isPro
          # journey
          week
          order
          screensColor
          hormoneColor
          icon
          isStarted
          lastLoggedScreen
          isComplete
          progress
          isFoodJournaling
          externalArticleLink
          webflowArticleThumbnail {
            id
            title
            image
          }
        }
      }
      # id
      # title
      # description
      # duration
      # progress
      # isComplete
      # isLocked
      # isAllowed
      # color
      # icon
    }
  }
`;

const GET_THYROID_PROGRAM_SUMMARY = gql`
  query getThyroidProgramSummaryHealthCoach($programId: String!, $userId: String!) {
    getThyroidProgramSummaryHealthCoach(programId: $programId, userId: $userId) {
      section {
        id
        name
        description
        isActive
        isArchived
        isPro
        memberOnly
        createdAt
        updatedAt
        order
      }
      courses {
        id
        title
        description
        bgMainColor
        bgBubblesColor
        titleColor
        descriptionColor
        order
        week
        icon
        webflowArticleId
        externalArticleLink
        isFoodJournaling
        isActive
        isArchived
        isPro
        memberOnly
        createdAt
        updatedAt
        isStarted
        lastLoggedScreen
        progress
        isComplete
        webflowArticleThumbnail {
          id
          title
          image
        }
      }
    }
  }
`;

const GET_COURSES_ANSWERS = gql`
  query healthCoachGetPatientMobileCoursesAnswers($patientId: String!, $courseId: String!) {
    healthCoachGetPatientMobileCoursesAnswers(patientId: $patientId, courseId: $courseId) {
      id
      isCompleted
      selectedOptions
      isStarted
      journaling
      date
      buttonClicked
      courseScreen {
        hormoneY
        Content
        externalArticleLink
        webflowArticleId
        textStyle
        titleStyle
        options
        buttons
        order
        title
      }
    }
  }
`;
const GET_KIT_STATUS = gql`
  query healthCoachGetKitStatus($labResultId: String!) {
    healthCoachGetKitStatus(labResultId: $labResultId) {
      id
      status
      barcode
      deliveryToPatientDate
      deliveryToLabDate
      businessDaysSinceLabReceipt
      slowLabFlag
      etaToCustomer
      etaToLab
      etaResults
      trackKitToCustomer
      trackKitToLab
      orderId
      alliedRef
    }
  }
`;

const GET_PRESET_PLAN_COURSES_ANSWERS = gql`
  query healthCoachGetPatientMobilePresetPlanAnswers($patientId: String!, $courseId: String!) {
    healthCoachGetPatientMobilePresetPlanAnswers(patientId: $patientId, courseId: $courseId) {
      id
      isCompleted
      selectedOptions
      isStarted
      journaling
      date
      buttonClicked
      programCourseScreen {
        hormoneY
        content
        externalArticleLink
        webflowArticleId
        textStyle
        titleStyle
        options
        buttons
        order
        title
      }
    }
  }
`;

const GET_FORM_CONTENT = gql`
  query getFormContent($formId: String!) {
    getFormContent(formId: $formId) {
      id
      creator {
        id
        email
        firstName
      }
      version
      content
      target {
        id
        target
      }
      name
      description
      basedOnTemplate {
        id
        name
        builderUpdatedAt
      }
      isActive
      isDeprecated
      isDeleted
      createdAt
      updatedAt
      builderUpdatedAt
    }
  }
`;

const GET_CARE_TEAM_CONVERSATION_ID = gql`
  query healthCoachGetCareTeamConversationId($helpscoutId: String!) {
    healthCoachGetCareTeamConversationId(helpscoutId: $helpscoutId)
  }
`;

const GET_PATIENT_PHYSICIAN_CONVERSATION_ID = gql`
  query providerGetUserPhysicianConversationsTree($userId: String!) {
    providerGetUserPhysicianConversationsTree(userId: $userId)
  }
`;

const GET_ENCOUNTER_SUMMARY = gql`
  query providersFullEncounterSummary($appointmentId: String, $patientId: String!, $target: String) {
    providersFullEncounterSummary(appointmentId: $appointmentId, patientId: $patientId, target: $target) {
      Patient_name
      ICD10
      SUBJECTIVE
      OBJECTIVE
      ASSESSMENT
      PRESCRIPTION_WRITTEN
    }
  }
`;

const GET_SOAP_DRAFT = gql`
  query getHpiSoapDraft($summary: String!, $hpi: String!) {
    getHpiSoapDraft(summary: $summary, hpi: $hpi) {
      subjective
      objective
      assessment
      plan
    }
  }
`;

export {
  GET_FEATURE_TOGGLES_LIST,
  CURRENT_USER,
  GET_ANALYTICS_ID,
  APPOINTMENTS,
  LABS,
  GET_USER_PCP,
  GET_LAST_SEENS,
  GET_UPCOMINGS,
  GET_PATIENT_BY_ID,
  SEARCH_PATIENT_BY_NAME,
  GET_PATIENT_SYMPTOMS,
  GET_LAB_CHART_VALUES,
  GET_PATIENT_MOBILE_COURSES,
  GET_APPOINTMENTS_AND_TICKLERS,
  GET_APPOINTMENT_SUMMARY,
  GET_CONVERSATIONS,
  GET_HELPSCOUT_USERS,
  GET_CONVERSATION_BY_ID,
  GET_CONVERSATIONS_SEARCH,
  GET_PATIENT_QUICKVIEW,
  GET_INSURANCE_ON_FILE_FOR_PATIENT,
  GET_CARE_LOCATIONS,
  GET_CONVERSATIONS_BY_APPOINTMENT_ID,
  GET_DASHBOARD_CARDS_DATA,
  GET_OPEN_CONVERSATION_COUNT,
  GET_CURRENT_INTAKE_VALUES,
  GET_PROFILE,
  GET_MEDICATIONS_ON_FILE,
  GET_MEDICATION_REMINDERS,
  GET_CALENDAR_FOR_MONTH,
  GET_TODAYS_UPCOMINGS,
  GET_LABS_LIST,
  GET_LAB_RESULT_DOCUMENTS,
  GET_LAB_RESULT_DOCUMENTS_PAGE,
  GET_AIP_RECIPES_BY_FILTER,
  GET_AIP_RECIPE,
  GET_ARTICLES_FOR_CATEGORY,
  GET_ARTICLES_CATEGORIES,
  GET_RANDOM_ARTICLES_WITH_TAG,
  GET_ARTICLE_BY_ID,
  GET_SPEAKER_SERIES,
  GET_THYROID_GUIDES,
  GET_PATIENT_CHART_ALERTS,
  GET_CALENDAR_BETWEEN_DATES,
  GET_PATIENT_PHOTO,
  GET_PATIENT_BASELINE_SURVEY_ANSWERS,
  GET_PATIENT_FOLLOWUP_SURVEY_ANSWERS,
  GET_PATIENT_SURVEYS_INFO,
  GET_PATIENT_CASES,
  GET_PATIENT_CASE,
  GET_TALKING_POINTS,
  GET_PATIENT_SURVEYS_AVERAGES,
  GET_HS_TAGS_LIST,
  GET_CLINICAL_TEAM_CONVERSATION_ID,
  GET_HPIS,
  GET_INTAKE_STATUS,
  GET_PRESET_PLANS,
  GET_THYROID_JOURNEY_SUMMARY,
  GET_THYROID_PROGRAM_SUMMARY,
  GET_COURSES_ANSWERS,
  GET_KIT_STATUS,
  GET_PRESET_PLAN_COURSES_ANSWERS,
  GET_FORM_CONTENT,
  GET_CARE_TEAM_CONVERSATION_ID,
  GET_PATIENT_PHYSICIAN_CONVERSATION_ID,
  GET_APPOINTMENT_NOTES,
  GET_ENCOUNTER_SUMMARY,
  GET_SOAP_DRAFT,
};
